import {
  MenuDividerType,
  MenuItemGroupType,
  MenuItemType,
  SubMenuType,
} from 'antd/es/menu/interface'

export const NO_NAVIGATE_KEY = 'no-navigate-key'

// Dùng để define type chặt chẽ hơn từ bên ngoài
export type ItemTypeKey =
  | 'default'
  | 'submenu'
  | 'item'
  | 'dynamic'
  | 'group'
  | 'divider'

export type CustomSubMenuType = Omit<SubMenuType, 'type' | 'children'> & {
  key: string
  type?: 'submenu'
  children: (
    | CustomSubMenuType
    | MenuDividerType
    | MenuItemGroupType
    | MenuItemType
  )[]
}

// Custom thêm 1 type dùng để render select
export type DynamicMenuItemType = Omit<SubMenuType, 'type' | 'children'> & {
  type: 'dynamic'
  children: CustomSubMenuType[]
}

export type DefaultMenuItemType<T extends ItemTypeKey = 'default'> =
  T extends 'submenu'
    ? CustomSubMenuType
    : T extends 'group'
    ? MenuItemGroupType
    : T extends 'divider'
    ? MenuDividerType
    : T extends 'item'
    ? MenuItemType & { type?: 'item' }
    :
        | (MenuItemType & { type?: 'item' })
        | CustomSubMenuType
        | MenuItemGroupType
        | MenuDividerType

export type CustomMenuItemType<T extends ItemTypeKey = 'default'> =
  T extends 'submenu'
    ? CustomSubMenuType
    : T extends 'group'
    ? MenuItemGroupType
    : T extends 'divider'
    ? MenuDividerType
    : T extends 'item'
    ? MenuItemType & { type?: 'item' }
    : T extends 'dynamic'
    ? DynamicMenuItemType
    :
        | (MenuItemType & { type?: 'item' })
        | CustomSubMenuType
        | MenuItemGroupType
        | MenuDividerType
        | DynamicMenuItemType
